var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapse-transition',[_c('ul',{staticClass:"ui-tree"},_vm._l((_vm.menuList),function(item,index){return _c('li',{key:index,class:[
				'tree-item',
				_vm.active === item[_vm.activeLabel] ? 'is-active' : '' ]},[_c('div',{staticClass:"tree-item-content",style:({ paddingLeft: _vm.paddingLeft + 'px' }),on:{"click":function($event){return _vm.toggle(item)}}},[_c('span',[_vm._v(_vm._s(item[_vm.props.label]))]),(
						item[_vm.props.children] &&
							item[_vm.props.children].length > 0
					)?_c('i',{class:[
						'el-icon-arrow-down',
						item.opened
							? 'el-icon-arrow-trans-down'
							: 'el-icon-arrow-trans-up' ],on:{"click":function($event){$event.stopPropagation();return _vm.openChild(index, item)}}}):_vm._e()]),(
					item[_vm.props.children] && item[_vm.props.children].length > 0
				)?_c('Item',{directives:[{name:"show",rawName:"v-show",value:(item.opened),expression:"item.opened"}],attrs:{"menuList":item[_vm.props.children],"props":_vm.props,"activeLabel":_vm.activeLabel,"active":_vm.active,"paddingLeft":_vm.padding},on:{"selected":_vm.selected}}):_vm._e()],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }